export default {
  PRODUCTS: (state) => {
    return state.products
  }
}
